import React, { useEffect, useState } from "react";
import { fetchBankDetails } from "../../../../../API/Bank/BankDetails";
import cookies from "../../../../../CommonFunction/cookies";
import Loader from "../../../../../CommonFunction/Loader";

const BankProfile = () => {
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const jwtToken = cookies.get('jwt');

  const fetchData = async () => {
    try {
      const data = await fetchBankDetails(jwtToken);
      setUserData(data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="root-style">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="bg-txtclr rounded-md md:p-8 p-5">
            <div className="md:gap-4">
              <div className="flex justify-between">
                <div>
                  <h1 className="font-semibold text-xl text-bgclr">
                    BASIC DETAILS
                  </h1>
                </div>
              </div>

              <div className="flex flex-col lg:flex-row gap-6 mt-2">
                <div className="bg-bgclr9 lg:w-[50%] px-5 py-3 border-[1px] border-[#000000] border-opacity-[20%] rounded-md">
                  <div className="text-[18px] leading-10">
                    <table className="w-full">
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">Bank Name: </td>
                        <td className="text-[#000000] ">
                          {userData?.name}
                        </td>
                      </tr>
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">Bank ID: </td>
                        <td>{userData?.bank_id}</td>
                      </tr>
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">Email: </td>
                        <td>{userData?.email}</td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div className="bg-bgclr9 lg:w-[50%] px-5 py-3 border-[1px] border-[#000000] border-opacity-[20%] rounded-md">
                  <div className="flex text-[18px] leading-10">
                    <table className="w-full">
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">
                        Contact no.:{" "}
                        </td>
                        <td>{userData?.phone_number}</td>
                      </tr>
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">
                          GST number :{" "}
                        </td>
                        <td>{userData?.personal?.gst_number}</td>
                      </tr>
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">
                          PAN no. :{" "}
                        </td>
                        <td>{userData?.personal?.pancard}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div className="flex gap-6 mt-5">
                <div className="bg-bgclr9 w-full px-5 py-3 border-[1px] border-[#000000] border-opacity-[20%] rounded-md">
                  <div className="text-[18px] leading-10">
                    <table className="w-full">
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[25%]">City Name: </td>
                        <td className="text-[#000000] ">
                          {userData?.address?.city}
                        </td>
                      </tr>
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[25%]">Pin Code: </td>
                        <td>{userData?.address?.pincode}</td>
                      </tr>
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[25%]">Address: </td>
                        <td>{userData?.address?.address}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div className="flex justify-between mt-10">
                <div>
                  <h1 className="font-semibold text-xl text-bgclr">
                    Authorized Person Details
                  </h1>
                </div>
              </div>

              <div className="flex flex-col lg:flex-row gap-6 mt-2">
                <div className="bg-bgclr9 lg:w-[50%] px-5 py-3 border-[1px] border-[#000000] border-opacity-[20%] rounded-md">
                  <div className="text-[18px] leading-10">
                    <table className="w-full">
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">Name: </td>
                        <td className="text-[#000000] ">
                          {userData?.poc?.name}
                        </td>
                      </tr>
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">Email ID: </td>
                        <td>{userData?.poc?.email}</td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div className="bg-bgclr9 lg:w-[50%] px-5 py-3 border-[1px] border-[#000000] border-opacity-[20%] rounded-md">
                  <div className="flex text-[18px] leading-10">
                    <table className="w-full">
                    <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">Contact no. : </td>
                        <td>{userData?.poc?.phone_number}</td>
                      </tr>
                      <tr className="flex items-start mb-3 leading-7">
                        <td className="text-gray-500 w-[42%]">
                          Designation :{" "}
                        </td>
                        <td>{userData?.poc?.designation}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BankProfile;
